export const COMPETENCY_KART = 'KART'
export const COMPETENCY_TDNA = 'TDNA'
export const COMPETENCY_TKA = 'TKA'